export default __webpack_public_path__ + "static/3-615c800f04c3bab964c6a131c1f8ec68.jpeg";